import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/jubao_checked_red.png';

const _withScopeId = n => (_pushScopeId("data-v-48df0a10"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "head_title"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "发布求片", -1));

const _hoisted_3 = {
  class: "cont_body"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "wantAv-title"
}, "求片内容", -1));

const _hoisted_5 = {
  class: "textarea"
};
const _hoisted_6 = {
  class: "num"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "wantAv-title"
}, [/*#__PURE__*/_createTextVNode("原视频"), /*#__PURE__*/_createElementVNode("span", null, "我想找续集")], -1));

const _hoisted_8 = {
  class: "info-recommend"
};
const _hoisted_9 = {
  class: "info-videoItem"
};
const _hoisted_10 = {
  class: "info-videoCover"
};
const _hoisted_11 = {
  class: "info-videoCover-img"
};
const _hoisted_12 = {
  class: "info-videoInfo"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "wantAv-title",
  style: {
    "margin-top": "0.5rem"
  }
}, " 打赏金额（赏银/个） ", -1));

const _hoisted_14 = {
  class: "wantAv-input-box"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "thin-line"
}, null, -1));

const _hoisted_16 = {
  class: "wantAv-footer"
};
const _hoisted_17 = {
  class: "wantAv-row"
};
const _hoisted_18 = {
  class: "wantAv-row"
};

const _hoisted_19 = /*#__PURE__*/_createTextVNode("请阅读并遵守");

const _hoisted_20 = {
  class: "details_page"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_my_image = _resolveComponent("my-image");

  const _component_ask_video_gz = _resolveComponent("ask-video-gz");

  const _component_van_popup = _resolveComponent("van-popup");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_icon, {
    size: "22",
    name: "arrow-left",
    onClick: $setup.close
  }, null, 8, ["onClick"]), _hoisted_2]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("textarea", {
    maxlength: "150",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.content = $event),
    placeholder: "可以输入你对视频的玩法要求，也可输入想看的类型、片名、演员名称、番号...,至少10字且注意格式"
  }, null, 512), [[_vModelText, $setup.content]]), _createElementVNode("p", _hoisted_6, _toDisplayString($setup.content ? $setup.content.length : 0) + "/150", 1)]), _hoisted_7, _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_createVNode(_component_my_image, {
    url: $setup.videoDetails.image
  }, null, 8, ["url"])])]), _createElementVNode("span", null, _toDisplayString($setup.videoDetails.times), 1)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("p", null, _toDisplayString($setup.videoDetails.title), 1), _createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString($setup.videoDetails.nickname || $setup.videoDetails.user_name), 1), _createElementVNode("span", null, _toDisplayString($setup.videoDetails.count) + "次播放", 1)])])])]), _hoisted_13, _createElementVNode("div", _hoisted_14, [_withDirectives(_createElementVNode("input", {
    type: "number",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.money = $event),
    placeholder: "设置打赏推荐更积极收获多多"
  }, null, 512), [[_vModelText, $setup.money]]), _hoisted_15])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [!$setup.isYdguize ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.ydgzClick && $setup.ydgzClick(...args)),
    class: "wantAv-circle"
  })) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.ydgzClick && $setup.ydgzClick(...args)),
    src: _imports_0
  })), _createElementVNode("span", _hoisted_18, [_hoisted_19, _createElementVNode("span", {
    onClick: _cache[4] || (_cache[4] = (...args) => $setup.toGz && $setup.toGz(...args)),
    class: "wantAv-blue"
  }, "《棒棒视频发布规则》")])]), _createElementVNode("div", {
    class: "wantAv-btn",
    onClick: _cache[5] || (_cache[5] = (...args) => $setup.faBuAskVideo && $setup.faBuAskVideo(...args))
  }, "发布")])]), _createVNode(_component_van_popup, {
    show: $setup.showAskVideoGz,
    "onUpdate:show": _cache[6] || (_cache[6] = $event => $setup.showAskVideoGz = $event),
    class: "popup_coentent",
    overlay: false,
    position: "right"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createVNode(_component_ask_video_gz, {
      onClose: $setup.close1
    }, null, 8, ["onClose"])])]),
    _: 1
  }, 8, ["show"])]);
}